

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function(_defaultTemplate, item, html) {
    if(item.attribute == 'meta.custom.color'){
      return html`
          <label class="${item.cssClasses.label}">
              ${item.type === 'disjunctive' &&
                  (item.isRefined
                      ? html`
                          <input
                              type="checkbox"
                              class="${item.cssClasses.checkbox}"
                              checked
                          />
                      `
                  : html`
                      <input type="checkbox" class="${item.cssClasses.checkbox}" />
                  `)
              }
              <div
                  class="filter-item__swatch"
                  style="
                      background-image: url(//www.harimari.com/cdn/shop/files/${item.label.toLowerCase()}.png);
                      background-color: ${item.label.toLowerCase()};
                  "
              ></div>
              ${item.label}
                  <span class="${item.cssClasses.count}">
                      ${algoliaShopify.helpers.formatNumber(item.count)}
                  </span>
          </label>
      `;
    }else{
      if(item.attribute == 'meta.custom.collection'){
        labelArray = item.label.split('-');
  
        for (let i = 0; i < labelArray.length; i++) {
          labelArray[i] = labelArray[i][0].toUpperCase() + labelArray[i].substr(1);
        }
  
        if(labelArray.length > 0){
          item.label = labelArray.join(" ");
        }
      }

      return html`
        <label class="${item.cssClasses.label}">
          ${item.type === 'disjunctive' &&
            (item.isRefined
              ? html`
                  <input
                    type="checkbox"
                    class="${item.cssClasses.checkbox}"
                    checked
                  />
                `
              : html`
                  <input type="checkbox" class="${item.cssClasses.checkbox}" />
                `)}
          ${item.label}
          <span class="${item.cssClasses.count}">
            ${algoliaShopify.helpers.formatNumber(item.count)}
          </span>
        </label>
      `;
    }
  });

  // to replace "Sorted by" to "Filter by"
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    console.log('data_many_pp: ','background-color:blue',data);

    return html`
        <div class="ais-page">
          <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
          <div class="ais-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-facets-button">
            Show filters
          </div>
          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map(
              facet =>
                html`
                  <div
                    class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                  >
                    <label
                      for="${facet.escapedName}"
                      class="ais-range-slider--header ais-facet--header ais-header"
                      >${facet.title}</label
                    >
                    <input
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                    />
                    <div
                      class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                    ></div>
                  </div>
                `
            )}
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      Filter by
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html`
                      Filter by
                      ${algoliaShopify.translations.relevance}
                    `}
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
             <div class="button-see-all" style="display:none"><a href="/search?q=">See all Products</a></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
    console.log('data_many: ','background-color:blue',data.hasManyResults);
    if(!data.hasManyResults){ 
      let not_result_div = document.querySelector('.button-see-all');
      console.log(not_result_div);
      not_result_div.style.display ="block";
    }
    return html`
      ${data.hasOneResult &&
        html`
          <span class="ais-stats--nb-results">
            1 result found
          </span>
      `}
      ${data.hasManyResults &&
        html`
          ${data.page * data.hitsPerPage + 1} - ${' '}
          ${Math.min((data.page + 1) * data.hitsPerPage, data.nbHits)} ${' '}
          out of
          <span class="ais-stats--nb-results">
            ${' '} ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '}
            results found
          </span>
      `}
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function (_defaultTemplate, templateOptions, distinct, itemLink, handleItemClick) {
    const { html, item, components } = templateOptions;
    return html` 
      <a
        href="${itemLink}"
        class="aa-ItemLink aa-ProductItem"
        onClick="${(event) => handleItemClick(event, item)}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemPicture aa-ItemPicture--loaded">
            <img
              src="${algoliaShopify.helpers.largeImage(item)}"
              alt="${item.title}"
            />
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitleWrapper">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: "title" })}
                <span class="algolia-variant">
                  ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                </span>
              </div>
            </div>
            <div class="aa-ItemContentPrice">
              <div class="aa-ItemContentPriceCurrent">
               <b class="t-subdued"> ${algoliaShopify.helpers.displayStrikedPrice(
                  item.price,
                  item.compare_at_price
                )}</b>
                ${algoliaShopify.helpers.displayPrice(item)}
              
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });


  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
  
    const productHtml = html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${(event) => handleItemClick(event, hit)}"
      >
  
        <div class="image-container">
          <img
            class="ais-hit--picture"
            src="${algoliaShopify.helpers.largeImage(hit)}"
            alt="${hit.title} - ${hit.variant_title}"
          />
          <img
            class="hover-image"
            src="${algoliaShopify.helpers.compactImage(hit)}"
            alt="${hit.title} - ${hit.variant_title}"
          />
        </div>
  
         <div class="algolia-product-info">
            <div class="ais-hit--details">
              <p class="ais-hit--title test">
                <a
                  data-algolia-index="${hit.index}"
                  data-algolia-position="${hit.productPosition}"
                  data-algolia-queryid="${hit.queryID}"
                  data-algolia-objectid="${hit.objectID}"
                  href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                  onclick="void(0)"
                  title="${algoliaShopify.helpers.fullTitle(
                    hit.title,
                    hit._distinct,
                    hit.variant_title
                  )}"
                >
                  ${components.Highlight({ attribute: 'title', hit })}
                  ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
                </a>
              </p>
              <p
                class="ais-hit--subtitle"
                title="${hit.product_type}${algoliaShopify.translation_helpers.by(
                  hit.vendor
                )}"
              >
                ${components.Highlight({ attribute: 'product_type', hit })}
                ${hit.vendor &&
                  html`
                    <span> ${algoliaShopify.translations.by} </span>
                  `}
                ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
              </p>
              <p class="ais-hit--price">
              ${
                  html`
                    <span 
                      ><span class="ais-hit--price-striked striked-price test"
                        >${algoliaShopify.helpers.displayStrikedPrice(
                          hit.price,
                          hit.compare_at_price
                        )}</span
                      ></span
                    >
                  `}
                <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
              
                ${!hit._distinct &&
                  html`
                    <span class="ais-hit--price-discount"
                      >${algoliaShopify.helpers.displayDiscount(
                        hit.price,
                        hit.compare_at_price,
                        hit.price_ratio
                      )}</span
                    >
                  `}
              </p>
               <!--<div data-oke-star-rating data-oke-reviews-product-id="shopify-${hit.id}">
                </div>-->
              <!-- Extra info examples - Remove the display: none to show them -->
              <p class="ais-hit--info" style="display: none">
                ${hit.sku &&
                  html`
                    <span class="algolia-sku"
                      >${components.Highlight({ attribute: 'sku', hit })}</span
                    >
                  `}
                ${hit.barcode &&
                  html`
                    <span class="algolia-barcode"
                      >${components.Highlight({ attribute: 'barcode', hit })}</span
                    >
                  `}
                ${hit.weight &&
                  html`
                    <span class="algolia-weight">${hit.weight}</span>
                  `}
                ${!hit.taxable &&
                  html`
                    <span class="algolia-taxable"
                      >${algoliaShopify.translations.taxFree}</span
                    >
                  `}
              </p>
              <!-- Tags example - Remove the display: none to show them -->
              <p class="ais-hit--tags" style="display: none">
                ${hit?._highlightResult.tags?.map(
                  tag =>
                    html`
                      <span class="ais-hit--tag">${tag.value}</span>
                    `
                )}
              </p>
              ${!hit._distinct &&
                html`
                  <form
                    id="algolia-add-to-cart-${hit.objectID}"
                    style="display: none;"
                    action="/cart/add"
                    method="post"
                    enctype="multipart/form-data"
                  >
                    <input type="hidden" name="id" value="${hit.objectID}" />
                  </form>
                  <p class="ais-hit--cart">
                    ${hit.can_order
                      ? html`
                          <button
                            class="ais-hit--cart-button"
                            data-form-id="algolia-add-to-cart-${hit.objectID}"
                          >
                            ${algoliaShopify.translations.addToCart}
                          </button>
                        `
                      : html`
                          <button
                            class="ais-hit--cart-button ais-hit--cart-button__disabled"
                          >
                            ${algoliaShopify.translations.outOfStock}
                          </button>
                        `}
                  </p>
                `}
            </div>
            ${(() => {
              let strikedPrice = algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price);
              if(strikedPrice.length > 0){
                return html`<div class="algolia-sale">Sale</div>`;
              }
            })()}
          </div>
        </div>
      `;
  
  
    const productAjaxURL = `/products/${hit.handle}.js`;

    fetch(productAjaxURL)
      .then(response => response.json())
      .then(data => {
  
      //  console.log(data);
  
        //const widgetElements = document.querySelectorAll(`.ais-product[data-handle="${hit.handle}"] [data-oke-star-rating]`);
      //  console.log(widgetElements);
     /*   widgetElements.forEach(widget => {
          console.log(widget);
          window.okeWidgetApi.initWidget(widget);
        });*/

        if (data.images && data.images.length > 1) {
          const hoverImage = document.querySelector(`.ais-product[data-handle="${hit.handle}"] .hover-image`);
          console.log(hoverImage);
          if (hoverImage) {
            hoverImage.src = data.images[1]; 
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  
    return productHtml;
  });

  
  
});
  